import { createContext, useContext } from 'react';
export const A11yWizardAdapterContext = /*#__PURE__*/createContext(undefined);
export const useA11yWizardAdapter = () => {
  const context = useContext(A11yWizardAdapterContext);
  if (!context) {
    throw new Error('useA11yWizard must be used within an A11yWizardProvider');
  }
  return context;
};
//# sourceMappingURL=use-a11y-wizard-adapter.js.map